export const frontmatter = {
    "draft": true,
    "title": "GitHub Integration",
    "description": "Authentication and access to OnnIA using a GitHub account.",
    "sidebar_label": "GitHub",
    "sidebar_group": "guides",
    "sidebar_order": 5
}

export const toc = []